import axios from 'axios'

let processQuery = (path, query, defaultQuery = {}) => {
  query = Object.assign({}, defaultQuery, query)
  if (Object.keys(query).length) {
    let queryParts = []

    for (let key in query) {
      let value = query[key]
      if (Array.isArray(value)) {
        value.forEach(val => queryParts.push(key + '[]=' + encodeURIComponent(val)))
      } else {
        queryParts.push(key + '=' + encodeURIComponent(value))
      }
    }

    path = `${path}?${queryParts.join('&')}`
  }
  return path
}

function request(method, url, data = {}, token) {
  const params = {
    method,
    url,
    data,
  }

  if (token)
    params.headers = {
      authorization: `Bearer ${token}`,
    }

  return axios(params).catch(err => {
    // If 403, reset localstorage
    if (err.response && err.response.status === 403) {
      const [_empty, _prefix, org_id] = window.location.pathname.split('/')
      if (localStorage[`token_${org_id}`]) {
        localStorage.removeItem(`token_${org_id}`)
        window.location.reload()
      }
    }

    console.log(err)
    err._apierror = true
    throw err
  })
}

export const api = {
  get: (path, query) => request('GET', process.env.API_ROOT + processQuery(path, query), {}),
  post: (path, body, query = {}) => request('POST', process.env.API_ROOT + processQuery(path, query), body),
}

export const tokenApi = {
  get: (token, path, query) => request('GET', process.env.API_ROOT + processQuery(path, query), {}, token),
  post: (token, path, body, query = {}) =>
    request('POST', process.env.API_ROOT + processQuery(path, query), body, token),
  patch: (token, path, body, query = {}) =>
    request('PATCH', process.env.API_ROOT + processQuery(path, query), body, token),
  delete: (token, path) => request('DELETE', process.env.API_ROOT + path, {}, token),
}

export default api
